/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapMutations, mapGetters } from 'vuex';
import { getOrderDetailCtrlList as _getOrderDetailCtrlList, putPhonelog, getHdOrderDetailsh5, updateOrderGroupId, workerBespokeDate, startService } from '@/api';
import ViewBox from "vux/src/components/view-box/index.vue";
import Tab from "vux/src/components/tab/tab.vue";
import TabItem from "vux/src/components/tab/tab-item.vue";
import TransferDom from "vux/src/directives/transfer-dom/index.js";
import Popup from "vux/src/components/popup/index.vue";
import XTextarea from "vux/src/components/x-textarea/index.vue";
import Group from "vux/src/components/group/index.vue";
import Datetime from "vux/src/components/datetime/index.vue";
import OrderBottomOptions from './components/OrderBottomOptions/index'; // import CreateOrderPopup from '@/package/order/entry/components/CreateOrderPopup'

import Skeleton from '@/components/Common/Skeleton';
import SlideTransition from '@/components/Common/SlideTransition';
import editSynergModel from './components/editSynergModel';
import FormMobile from '@/components/Base/FormMobile';
export default {
  name: 'OrderDetail',
  components: {
    Skeleton: Skeleton,
    ViewBox: ViewBox,
    Tab: Tab,
    TabItem: TabItem,
    SlideTransition: SlideTransition,
    OrderBottomOptions: OrderBottomOptions,
    // CreateOrderPopup,
    editSynergModel: editSynergModel,
    XTextarea: XTextarea,
    Popup: Popup,
    FormMobile: FormMobile,
    Group: Group,
    Datetime: Datetime,
    OrderInfo: function OrderInfo() {
      return import('./components/OrderInfo');
    },
    ServiceContent: function ServiceContent() {
      return import('./components/ServiceContent');
    },
    ServiceSchedule: function ServiceSchedule() {
      return import('./components/ServiceSchedule');
    }
  },
  props: {
    orderId: {
      type: [String, Number],
      required: true
    }
  },
  directives: {
    TransferDom: TransferDom
  },
  data: function data() {
    return {
      isShowTemplate: false,
      formData: {},
      skeLoading: true,
      baseInfo: {},
      orderInfo: {},
      objectFiles: [],
      workerList: [],
      cooperateList: [],
      serverOrderFiles: [],
      showReorder: false,
      editSynergyShow: false,
      coordList: [],
      isdispatchGroup: false,
      showSubscribe: false,
      formSubscribe: {},
      isPosition: false,
      longitude: '',
      latitude: '',
      currAddress: '',
      currValue: '',
      isAssign: true
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('globalStore', ['user', 'orderTabsIndexMap'])), mapGetters('global', ['getStateName'])), {}, {
    tabsIndex: {
      get: function get() {
        var obj = this.orderTabsIndexMap;
        return obj[this.orderId] || 0;
      },
      set: function set(v) {
        var obj = this.orderTabsIndexMap;
        this.$set(obj, this.orderId, v);

        this._orderTabsIndexMap(obj);
      }
    },
    currentComponent: function currentComponent() {
      return this.componentsList[this.tabsIndex] || this.componentsList[0];
    },
    componentId: function componentId() {
      return this.currentComponent && this.currentComponent.componentId;
    },
    stateInfo: function stateInfo() {
      return this.getStateName(this.baseInfo.order_state, 'dispatchState');
    },
    componentsList: function componentsList() {
      var componentsList = [{
        componentId: 'OrderInfo',
        show: true,
        name: '工单信息'
      }, {
        componentId: 'ServiceContent',
        show: true,
        name: '服务内容'
      }, {
        componentId: 'ServiceSchedule',
        show: true,
        name: '服务进度'
      }];
      return componentsList;
    },
    bottomPX: function bottomPX() {
      if (this.baseInfo.order_state == 5 || this.baseInfo.order_state == 6) {
        return 0;
      }

      return 50;
    },
    btnList: function btnList() {
      var arr;

      if (this.baseInfo.order_state == 0) {
        arr = [{
          type: 1,
          name: '返单'
        }, {
          type: 2,
          name: '受理工单'
        }];
        return arr;
      } else if (this.baseInfo.order_state == 1) {
        arr = [{
          type: 3,
          name: '转派团队'
        }, {
          type: 4,
          name: '指派人员'
        }];
        return arr;
      } else if (this.baseInfo.order_state == 2) {
        arr = [{
          type: 5,
          name: '预约'
        }];
        return arr;
      } else if (this.baseInfo.order_state == 3) {
        arr = [{
          type: 6,
          name: '开始服务'
        }];
        return arr;
      } else if (this.baseInfo.order_state == 4) {
        arr = [{
          type: 7,
          name: '添加进度'
        }, {
          type: 8,
          name: '服务完成'
        }];
        return arr;
      }
    }
  }),
  watch: {},
  methods: _objectSpread(_objectSpread({}, mapMutations('globalStore', ['_pageReload', '_orderTabsIndexMap'])), {}, {
    callback: function callback(e) {
      if (e == 1) {
        // 返单
        this.showReorder = true;
      } else if (e == 2) {
        // 受理
        this.$router.push({
          path: '/order/accept',
          query: {
            id: this.baseInfo.id
          }
        });
      } else if (e == 3) {
        // 转派团队
        this.isdispatchGroup = true;
      } else if (e == 4) {
        // 指派人员
        this.isAssign = true;
        this.editSynergyShow = true;
      } else if (e == 5) {
        // 预约
        this.showSubscribe = true;
      } else if (e == 6) {
        // 开始服务
        this.$vux.loading.show({
          text: '定位中...'
        });
        this.position();
      } else if (e == 7) {
        // 添加进度
        this.$router.push({
          path: '/order/addProcess',
          query: {
            // orderInfo: this.orderInfo,
            orderId: this.orderId,
            fk_t_order_id: this.baseInfo.fk_t_order_id,
            fk_t_hd_project_id: this.baseInfo.fk_t_hd_project_id
          }
        });
      } else if (e == 8) {
        // 完成服务
        this.$router.push({
          path: '/order/serviceCompletePage',
          query: {
            sign_time1: this.orderInfo.sign_time1,
            orderInfo: this.orderInfo,
            orderId: this.orderId
          }
        });
      } else if (e == 9) {
        // 重新指派
        this.isAssign = false;
        this.editSynergyShow = true;
      }
    },
    // 选择服务团队 回调
    dispatchClick: function dispatchClick(id) {
      var _this = this;

      updateOrderGroupId({
        orderId: this.orderInfo.oid,
        groupId: id
      }).then(function (res) {
        if (res.success) {
          _this.$vux.toast.text('转派成功');

          _this.init();
        } else {
          _this.$vux.toast.text(res.message);
        }
      });
    },
    // 定位
    position: function position() {
      var _this2 = this;

      var content,
          distance,
          that = this;

      try {
        this.$DingTalk.device.geolocation.get({
          targetAccuracy: 100,
          // 精度半径
          coordinate: 1,
          // 1 高德坐标 2 标准坐标（无address字段）
          withReGeocode: true,
          // 是否返回逆地理编码信息
          useCache: true,
          // 是否缓存（开启后2分钟内再次请求返回缓存信息）
          onSuccess: function onSuccess(_ref) {
            var longitude = _ref.longitude,
                latitude = _ref.latitude,
                address = _ref.address;

            _this2.$vux.loading.hide();

            if (address && longitude && latitude) {
              _this2.longitude = longitude;
              _this2.latitude = latitude;
              _this2.currAddress = address;
              _this2.currValue = [longitude, latitude];
              _this2.isPosition = true;
              distance = _this2.getDistance();
              content = "\u60A8\u5F53\u524D\u7684\u5730\u5740\u662F".concat(address, "\uFF0C\u8DDD\u79BB").concat(distance, "\u7C73");
            } else {
              content = '定位异常，是否开始服务？';
            }

            _this2.confirmFun(content, distance);
          },
          onFail: function onFail(e) {
            _this2.confirmFun();
          }
        });
      } catch (error) {
        this.$vux.loading.hide();
        this.confirmFun();
      }
    },
    confirmFun: function confirmFun() {
      var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '定位异常，是否开始服务？';
      var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
      var that = this;
      this.$vux.confirm.show({
        title: '提示',
        content: content,
        cancelText: '取消',
        confirmText: '确定',
        hideOnBlur: true,
        onShow: function onShow() {},
        onHide: function onHide() {},
        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          that.startServiceFun(distance);
        }
      });
    },
    // 开始服务
    startServiceFun: function startServiceFun(distance) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var obj, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                obj = {
                  orderId: _this3.orderInfo.oid,
                  distance: distance,
                  longitude: _this3.longitude,
                  latitude: _this3.latitude,
                  address: _this3.address,
                  code: '1'
                };
                _context.next = 3;
                return startService(obj);

              case 3:
                res = _context.sent;

                if (res.success) {
                  _this3.$vux.toast.text('开始服务');

                  _this3.init();
                } else {
                  _this3.$vux.toast.text(res.message);
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 计算经纬度
    getDistance: function getDistance() {
      // 获取客户经纬度
      var customLatitude = this.orderInfo.custom_latitude;
      var customLongitude = this.orderInfo.custom_longitude; // 计算距离

      var PI = Math.PI;
      var EARTH_RADIUS = 6378137.0;

      var getRad = function getRad(d) {
        return d * PI / 180.0;
      };

      getDistance(customLatitude, customLongitude, this.longitude, this.latitude);

      var getDistance = function getDistance(lng1, lat1, lng2, lat2) {
        if (lng2 === null || lng2 === '' || lng2 === 'null') {
          return -1;
        }

        var radLat1 = getRad(lat1);
        var radLat2 = getRad(lat2);
        var a = radLat1 - radLat2;
        var b = getRad(lng1) - getRad(lng2);
        var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
        s = s * EARTH_RADIUS;
        s = Math.round(s * 10000) / 10000.0;
        s = Math.round(s);
        return s;
      };
    },
    init: function init() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.skeLoading = true;
                _context2.next = 3;
                return getHdOrderDetailsh5({
                  id: _this4.orderId
                });

              case 3:
                res = _context2.sent;
                console.log(11, res.data);

                if (res.data.success) {
                  _this4.baseInfo = res.data.data;
                  _this4.orderInfo = res.data.data.orderInfo || {};
                  _this4.objectFiles = res.data.data.objectFiles || [];
                  _this4.workerList = res.data.data.workerList || [];
                  _this4.cooperateList = res.data.data.cooperateList || [];
                  _this4.serverOrderFiles = res.data.data.serverOrderFiles || [];
                }

                _this4.skeLoading = false;

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getRight: function getRight() {
      var _this5 = this;

      var item = [{
        id: 'reorder',
        text: '返单'
      }];

      if (this.baseInfo.order_state == 2 || this.baseInfo.order_state == 3 || this.baseInfo.order_state == 4) {
        item.push({
          id: 'assign',
          text: '重新指派'
        }, {
          id: 'assignTeam',
          text: '转派团队'
        });
      }

      if (this.baseInfo.order_state == 4) {
        item.push({
          id: 'scan',
          text: '扫码',
          iconId: 'scan',
          url: require('@/assets/icon/scan.png')
        });
      }

      var that = this;
      this.$DingTalk.biz.navigation.setMenu({
        items: item,
        onSuccess: function onSuccess(_ref2) {
          var id = _ref2.id;
          var type;

          if (id == 'reorder') {
            type = 1;
          } else if (id == 'assign') {
            type = 9;
          } else if (id == 'assignTeam') {
            type = 3;
          } else if (id == 'scan') {
            return _this5.$DingTalk.biz.util.scan({
              onSuccess: function onSuccess(_ref3) {
                var _ref3$text = _ref3.text,
                    text = _ref3$text === void 0 ? '' : _ref3$text;
                var code = text.split('/')[text.split('/').length - 1];

                _this5.getIdByQRCode(decodeURI(decodeURI(code)));
              },
              onFail: function onFail(err) {
                console.log('scan-err', err);
              }
            });
          }

          type && that.callback(type);
        }
      });
    },
    goProduct: function goProduct(id) {
      this.$router.push({
        name: 'Product',
        query: {
          productId: id
        }
      });
    },
    reloadTab: function reloadTab(tab) {
      if (this.$refs[tab] && this.$refs[tab].reload) {
        this.$refs[tab].reload();
      }
    },
    showUpdate: function showUpdate(title, content) {
      this.$vux.confirm.show({
        title: title,
        content: content,
        cancelText: '取消',
        confirmText: '立即升级',
        hideOnBlur: true,
        onShow: function onShow() {},
        onHide: function onHide() {},
        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {}
      });
    },
    // 隐藏客户信息
    hideInfo: function hideInfo(str, frontLen, endLen) {
      var len = str.length - frontLen - endLen;
      var xing = '';

      for (var i = 0; i < len; i++) {
        xing += '*';
      }

      return str.substring(0, frontLen) + xing + str.substring(str.length - endLen);
    },
    // 验证手机
    validatePhone: function validatePhone(phone) {
      var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      var number = '';

      if (myreg.test(phone)) {
        number = this.hideInfo(phone, 3, 4);
      } else if (phone.length > 4) {
        number = this.hideInfo(phone, 0, 4);
      } else if (phone.length < 4) {
        number = this.hideInfo(phone, 1, 0);
      }

      return number;
    },
    // 获取地址  打开地图
    location: function location() {
      if (!this.orderInfo) return;

      if (this.orderInfo.custom_latitude === 0 || this.orderInfo.custom_longitude === 0) {
        this.$vux.toast.text('地址异常');
      } else {
        this.$DingTalk && this.$DingTalk.biz.map.view({
          latitude: this.orderInfo.custom_latitude,
          // 纬度
          longitude: this.orderInfo.custom_longitude,
          // 经度
          title: this.orderInfo.gps_addr
        });
      }
    },
    // 打电话
    tel: function tel(phone) {
      var _this6 = this;

      this.$DingTalk && this.$DingTalk.biz.telephone.showCallMenu({
        phoneNumber: phone,
        // 期望拨打的电话号码
        code: '+86',
        // 国家代号，中国是+86
        showDingCall: true,
        // 是否显示钉钉电话
        onSuccess: function onSuccess() {
          putPhonelog({
            oid: _this6.orderInfo.oid,
            clientName: _this6.orderInfo.custom_name
          }).then(function (res) {
            _this6.reloadTab('orderLog');
          });
        },
        onFail: function onFail() {}
      });
    },
    message: function message() {},
    pushDetail: function pushDetail() {
      if (this.orderInfo && this.orderInfo.fk_t_customer_id) {
        this.$router.push({
          name: 'CustomerDetail',
          params: {
            customerId: this.orderInfo.fk_t_customer_id,
            oid: this.orderInfo.orderId
          }
        });
      } else {
        this.$vux.toast.text('此客户不存在');
      }
    },
    reload: function reload(flag) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    editcount: function editcount() {
      this.reload();
    },
    orderexecute: function orderexecute() {},
    serviceamount: function serviceamount() {
      this.reload();
      this.reloadflag = true;
      this.reloadTab('serviceAmount');
    },
    // 是否开启编辑协同人
    loadEnterprise: function loadEnterprise() {},
    // 获取明细控件tabs
    getOrderDetailCtrlList: function getOrderDetailCtrlList() {
      var _this7 = this;

      _getOrderDetailCtrlList({
        oid: this.orderId
      }).then(function (res) {
        if (res.success) _this7.detailCtrlList = res.data || [];
      });
    },
    // 预约
    sumbitSubscribe: function sumbitSubscribe() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var obj, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this8.formSubscribe.bespokeDate) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", _this8.$vux.toast.text('请选择预约时间'));

              case 2:
                obj = {
                  orderId: _this8.orderInfo.oid,
                  bespokeDate: _this8.formSubscribe.bespokeDate,
                  appoint_remark: _this8.formSubscribe.appoint_remark
                };
                _context4.next = 5;
                return workerBespokeDate(obj);

              case 5:
                res = _context4.sent;

                if (res.success) {
                  _this8.$vux.toast.text('预约成功');

                  _this8.showSubscribe = false;

                  _this8.init();
                } else {
                  _this8.$vux.toast.text(res.message);
                }

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }),
  created: function created() {
    this.init();
  },
  destroyed: function destroyed() {
    this.$DingTalk && this.$DingTalk.biz.navigation.setRight({
      show: false
    });
  }
};